var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560,165.7c0-0.8-0.2-1.6-0.4-2.4v-0.8c-0.4-0.9-1-1.7-1.7-2.4L435.4,37.6c-0.7-0.7-1.5-1.2-2.4-1.7h-0.8h0 c-0.9-0.5-1.9-0.8-2.9-1H183.8c-4.8,0-8.8,3.9-8.8,8.8V280h-26.2c-4.8,0-8.8,3.9-8.8,8.8v157.5c0,2.3,0.9,4.5,2.6,6.2 s3.9,2.6,6.2,2.6H175v61.3c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h367.5c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2v-350L560,165.7 L560,165.7z M437.5,64.8l92.7,92.7h-92.7V64.8z M157.5,297.5H420v140H157.5V297.5z M192.5,507.5V455h236.2c2.3,0,4.5-0.9,6.2-2.6 s2.6-3.9,2.6-6.2V288.8c0-2.3-0.9-4.5-2.6-6.2s-3.9-2.6-6.2-2.6H192.5V52.5H420v113.8c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h113.8 v332.5H192.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.9,375.6h10.7c3.4,0.1,6.8-0.6,9.9-2c3.6-1.6,6.7-4.3,8.8-7.7c2.1-3.5,3.1-7.6,3.1-11.6c0.2-6.4-2.4-12.6-7.3-16.8 c-4.7-3.7-10.6-5.5-16.6-5.1h-22.9v70h14.8L206.9,375.6z M206.9,345.8h8.2c6.4,0,9.6,2.7,9.6,8.1c0.1,2.5-0.8,4.9-2.5,6.6 c-1.9,1.7-4.5,2.6-7.1,2.4h-8.2V345.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M263.9,360.1l30.2,42.4H309v-70h-14.9v44.7L262,332.5h-12.9v70h14.8L263.9,360.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M353.1,403.7c7.4-0.2,14.5-2.9,20-7.8v6.6h13.2v-39h-30.9v13.3h17.5v0c-0.6,3.6-2.7,6.8-5.9,8.8c-3.6,2.3-7.7,3.5-12,3.3 c-5.5,0.2-10.9-2-14.8-6c-3.8-4.2-5.8-9.7-5.5-15.4c-0.2-5.6,1.8-11.1,5.6-15.3c3.6-4,8.7-6.2,14.1-6.1c6.9-1,13.5,3.2,15.3,10h16.6 c-0.9-7-4.6-13.3-10.1-17.5c-6-4.7-13.5-7.2-21.2-7c-9.5-0.2-18.6,3.6-25.1,10.6c-6.7,7.1-10.4,16.5-10.1,26.2 c-0.3,9.4,3.2,18.5,9.6,25.4C335.5,400.3,344.1,404,353.1,403.7L353.1,403.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.a3677ab0ffce3b3e39e7799ed09ca92a.svg";
export { ForwardRef as ReactComponent };